import { render, staticRenderFns } from "./Carousel.vue?vue&type=template&id=53346b3a&scoped=true&lang=pug"
import script from "./Carousel.vue?vue&type=script&lang=js"
export * from "./Carousel.vue?vue&type=script&lang=js"
import style0 from "./Carousel.vue?vue&type=style&index=0&id=53346b3a&lang=scss&scoped=true"
import style1 from "./Carousel.vue?vue&type=style&index=1&id=53346b3a&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53346b3a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspaces/wuwow-junior-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53346b3a')) {
      api.createRecord('53346b3a', component.options)
    } else {
      api.reload('53346b3a', component.options)
    }
    module.hot.accept("./Carousel.vue?vue&type=template&id=53346b3a&scoped=true&lang=pug", function () {
      api.rerender('53346b3a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/event/anniversary2023/components/Carousel.vue"
export default component.exports